import React, { Component } from "react";

export class UserProfileModal extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    window.UserProfileModal = this;
  }
  render() {
    let { props } = this;
    let { id, title, onClose, submitButton, closeButton } = props;
    let attrs = Object.except(props, ["id", "title", "type", "onClose"]);

    return (
      <AppModalBs id={id} title={title} onClose={onClose}>
        <AppFormData
          {...attrs}
          onClose={onClose}
          submitButton={submitButton}
          closeButton={closeButton}
        ></AppFormData>
      </AppModalBs>
    );
  }
}

export default UserProfileModal;
